import { Box } from "@material-ui/core";
import { QuoteLineItem } from "../../api/Quote/QuoteLineItem";
import { Quote } from "../../api/Quote/Quote";
import QuoteDetailsTable from "./components/QuoteDetailsTable";
import QuoteDetailsHeader from "./components/QuoteDetailsHeader";

interface Props {
  quote: Quote;
  onRemoveAddon: (addon: QuoteLineItem) => void;
  onInfoDialogOpen: (addon: QuoteLineItem) => void;
  payNextPageLink: string;
  isAvailableSchedule: boolean;
}

export const QuoteDetails = ({
  quote,
  onRemoveAddon,
  onInfoDialogOpen,
  payNextPageLink,
  isAvailableSchedule
}: Props) => {
  if (quote == null) {
    return null;
  }

  return (
    <Box>
      <QuoteDetailsHeader quote={quote} quoteName={quote.name} />

      <QuoteDetailsTable
        quote={quote}
        onRemoveAddon={onRemoveAddon}
        onInfoDialogOpen={onInfoDialogOpen}
        payNextPageLink={payNextPageLink}
        isAvailableSchedule={isAvailableSchedule}
      />
    </Box>
  );
};
